export enum ForeignPrescriptionStatus {
  PENDING = 1,
  SUBMITTED = 2,
  FULFILLED = 3,
  NOT_FULFILLED = 4,
  MANUAL_SUBMITTED = 5,
  FAILED_SUBMIT = 6,
  SUBMITTED_WITH_OBSERVATIONS = 7,
  PENDING_ASSIGNMENT = 8,
  ASSIGNED = 9,
  RESOLVED = 10,
  WAITING_FOR_PHARMACY = 21
}
